import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

function LibraryConfirmationDialog({
  isOpen,
  onCancel,
  onConfirm,
  title,
  description,
  children,
  confirmLabel,
  cancelLabel,
  confirmDisabled = false,
  isSubmitting = false,
  maxWidth = 'md',
  variant = '',
}) {
  const dialogClassName = [
    'library-confirmation-dialog',
    variant && `library-confirmation-dialog--${variant}`,
  ]
    .filter(Boolean)
    .join(' ');

  const handleCancel = () => {
    if (!isSubmitting) onCancel();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!confirmDisabled && !isSubmitting) onConfirm();
  };

  return (
    <Dialog
      className={dialogClassName}
      open={isOpen}
      onClose={handleCancel}
      fullWidth
      maxWidth={maxWidth}
      aria-labelledby="library-confirmation-dialog-title"
      aria-describedby="library-confirmation-dialog-description"
    >
      <form className="library-confirmation-dialog__form" onSubmit={handleSubmit}>
        <DialogTitle id="library-confirmation-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <Typography
            id="library-confirmation-dialog-description"
            className="library-confirmation-dialog__description"
            component="div"
          >
            {description}
          </Typography>
          {children}
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            className="btn secondary"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            {cancelLabel}
          </button>
          <button
            type="submit"
            className="btn"
            disabled={confirmDisabled || isSubmitting}
          >
            {confirmLabel}
          </button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default LibraryConfirmationDialog;
